import React, { useEffect, useState } from "react";
import { Table, Input, Button, Popconfirm, Form, Col, Row, Space } from "antd";
import moment from "moment";
import {
  DownCircleOutlined,
  PlusOutlined,
  UpCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "../../../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/delete-icon.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/crossIcon.svg";
import { ReactComponent as SaveIcon } from "../../../../assets/save-icon.svg";
import { ReactComponent as AttachIcon } from "../../../../assets/attach.svg";
import * as actions from "./redux/actions";
import SpinnerComponent from "../../../../components/spinner";
import NonEditRowAttach from "./nonEditRowAttachView";
import CustomCalendar from "../../../../components/calendar";
import RevisionsEditableCell from "./revisionsEditableCell";
// import AMultiSelect from "../../../../components/AMultiSelect";
import _ from "lodash";
import UseDistributionPermissions from "../../permissions/useDistributionPermissions";

function DistributionsTable({ parentRecordID, doc_distributions }) {
  console.log("doc_distributions", doc_distributions);
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [sortedInfo, setSortedInfo] = useState(null);
  const [editingLoading, setEditingLoading] = useState(false);
  const [currentUpdateObj, setCurrentUpdateObj] = useState({});
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);
  // images contains all attachments of item
  const [attachPopupVisible, setAttachPopupVisible] = useState(false);
  const [search, setSearch] = useState({});
  const [date, setDate] = useState(null);
  // const [activitiesCheckedList, setActivitiesCheckedList] = useState([]);
  // const [salesRepCheckedList, setSalesRepCheckedList] = useState([]);
  const [deletingActivityId, setDeleteActivityId] = useState();
  const [showTable, setShowTable] = useState(false);
  const [req, setReq] = useState(false);
  const [canView, canEdit, canDelete] = true;
  // = UseDistributionPermissions();

  const isEditing = (record) =>
    record.key === editingKey || record.id === editingKey;

  const {
    allProjectDistributions,
    fetchingLoading,
    updateLoading,
    isAddProjectDistribution,
    isUpdateProjectDistribution,
    deletingLoading,
  } = useSelector((state) => state.projectDistributionReducer);

  const { user } = useSelector((state) => state.authReducer);

  const handleUpdateStatus = (isAdd, isUpdate) => {
    dispatch(
      actions.updateProjectDistributionIsAddIsUpdate({
        isAddProjectDistribution: isAdd,
        isUpdateProjectDistribution: isUpdate,
      })
    );
  };

  useEffect(() => {
    let order = sortedInfo?.order === "ascend" ? "asc" : "desc";
    if (doc_distributions.length > 0) {
      let distribution_id = doc_distributions.map((rev) => rev.id);
      let sort = sortedInfo?.order && sortedInfo?.columnKey;
      let orderParam = sortedInfo?.order ? order : null;
      dispatch(
        actions.fetchProjectDistribution({
          id: parentRecordID,
          search: { ...search, distribution_id },
          sort,
          order: orderParam,
        })
      );
    } else {
      dispatch(actions.fetchProjectDistributionSuccess([]));
    }
  }, [req]);

  useEffect(() => {
    debouncedCallApi();
  }, [sortedInfo]);

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 1000)
  );

  useEffect(() => {
    setEditingLoading(updateLoading);
    if (!updateLoading) {
      setEditingKey("");
    }

    return () => {
      handleUpdateStatus(false, false);
    };
  }, [updateLoading]);

  useEffect(() => {
    if (allProjectDistributions.length === 0) {
      return setData(allProjectDistributions);
    } else if (allProjectDistributions.length > 0) {
      let updatedData = allProjectDistributions.map((el) => {
        const { distribution_attachments, ...rest } = el;

        let updatedImages;
        if (distribution_attachments?.length > 0) {
          updatedImages = distribution_attachments.map((img) => {
            const { url, id } = img;
            let name = url.split("/")[url.split("/").length - 1].split("?")[0];

            return { key: id, id, image: url, isLocal: false, name };
          });
        }

        return { ...rest, images: updatedImages };
      });
      setData(updatedData);
    }
  }, [allProjectDistributions]);

  const edit = (record) => {
    const { isAdd } = record;
    if (!isAdd) {
      setCurrentUpdateObj(record);
      let filteredItems = []
      // data.filter((el) => el.id !== editingKey);
      let final = []
      // filteredItems.filter((el) => el.key !== editingKey);
      setData(final);
      setImages(record?.images || []);
    }
    const { distribution_date } = record;
    form.setFieldsValue({
      ...record,
      distribution_date: moment(distribution_date),
      username: record?.user?.first_name + " " + record?.user?.surname,
    });
    !isAdd && handleUpdateStatus(false, true);
    setEditingKey(record.id);
  };

  const cancel = () => {
    if (isUpdateProjectDistribution) {
      setData(data);
    } else {
      // if (editingKey) {
      let filteredItems = []
      // data.filter((el) => el.id !== editingKey);
      let final = []
      // filteredItems.filter((el) => el.key !== editingKey);
      setData(final);
      // }
    }
    handleUpdateStatus(false, false);
    setEditingKey("");
  };

  const save = async (key) => {
    setEditingKey(key);
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex(
        (item) => key === item.key || key === item.id
      );
      if (index > -1) {
        form.submit();
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const searchInput = (key, placeholder) => (
    <Input
      placeholder={""}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        setSearch({
          ...search,
          [key]: e.target.value,
        });
        debouncedCallApi();
      }}
    />
  );

  const handleDateInput = (value) => {
    setDate(value);
    if (value === null) {
      setSearch({
        ...search,
        distribution_start_date: "",
        distribution_end_date: "",
      });
    } else {
      setSearch({
        ...search,
        distribution_start_date: value[0],
        distribution_end_date: value[1],
      });
    }
    debouncedCallApi();
  };

  const handleMultiSelect = (list, key) => {
    setSearch({
      ...search,
      [key]: list,
    });
    // debouncedCallApi();
  };

  const handleSelectOnchange = (value, options, key, setHandler) => {
    if (value.includes("all")) {
      setHandler([...options.map((item) => item.value)]);
      value = options.map((item) => item.value);
    } else if (value.includes("not-all")) {
      setHandler([]);
      value = [];
    } else {
      setHandler(value);
    }
    handleMultiSelect(value, key);
  };

  const onDeleteSuccess = () => {
    setDeleteActivityId();
    debouncedCallApi();
  };

  const deleteDistributionHandler = (record) => {
    setDeleteActivityId(record.id);
    dispatch(
      actions.deleteProjectDistribution({
        ...record,
        onDeleteSuccess,
        parentRecordID,
      })
    );
  };

  const columns = [
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">AREA</div>
            <div>{searchInput("area")}</div>
          </div>
        );
      },
      dataIndex: "area",
      key: "area",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "area" && sortedInfo?.order,
      width: 120,
      align: "center",
      editable: true,
      render: (area) => <div>{area}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">ASSEMBLY NO</div>
            <div>{searchInput("assemblyNo")}</div>
          </div>
        );
      },
      dataIndex: "assemblyNo",
      key: "assemblyNo",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "assemblyNo" && sortedInfo?.order,
      width: 150,
      align: "center",
      editable: true,
      render: (assemblyNo) => <div>{assemblyNo}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">REV</div>
            <div>{searchInput("rev")}</div>
          </div>
        );
      },
      dataIndex: "rev",
      key: "rev",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "rev" && sortedInfo?.order,
      width: 70,
      align: "center",
      editable: true,
      render: (rev) => <div>{rev}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">UNIQUE ID</div>
            <div>{searchInput("unique_id")}</div>
          </div>
        );
      },
      dataIndex: "unique_id",
      key: "unique_id",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "unique_id" && sortedInfo?.order,
      width: 120,
      align: "center",
      editable: true,
      render: (unique_id) => <div>{unique_id}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">QTY</div>
            <div>{searchInput("qty")}</div>
          </div>
        );
      },
      dataIndex: "qty",
      key: "qty",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "qty" && sortedInfo?.order,
      width: 70,
      align: "center",
      editable: true,
      render: (qty) => <div>{qty}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">MATERIAL TYPE</div>
            <div>{searchInput("material_type")}</div>
          </div>
        );
      },
      dataIndex: "material_type",
      key: "material_type",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "material_type" && sortedInfo?.order,
      width: 150,
      align: "center",
      editable: true,
      render: (material_type) => <div>{material_type}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">TOTAL/GROSS</div>
            <div>{searchInput("total_gross")}</div>
          </div>
        );
      },
      dataIndex: "total_gross",
      key: "total_gross",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "total_gross" && sortedInfo?.order,
      width: 120,
      align: "center",
      editable: true,
      render: (total_gross) => <div>{total_gross}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">PRIORITY</div>
            <div>{searchInput("priority")}</div>
          </div>
        );
      },
      dataIndex: "priority",
      key: "priority",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "priority" && sortedInfo?.order,
      width: 100,
      align: "center",
      editable: true,
      render: (priority) => <div>{priority}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">FABRICATION</div>
            <div>{searchInput("fabrication")}</div>
          </div>
        );
      },
      dataIndex: "fabrication",
      key: "fabrication",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "fabrication" && sortedInfo?.order,
      width: 120,
      align: "center",
      editable: true,
      render: (fabrication) => <div>{fabrication}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">QC RELEASE</div>
            <div>{searchInput("qc_release")}</div>
          </div>
        );
      },
      dataIndex: "qc_release",
      key: "qc_release",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "qc_release" && sortedInfo?.order,
      width: 120,
      align: "center",
      editable: true,
      render: (qc_release) => <div>{qc_release}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">CORROS. PROT. COL. WORKSH.</div>
            <div>{searchInput("corros_prot_col_worksh")}</div>
          </div>
        );
      },
      dataIndex: "corros_prot_col_worksh",
      key: "corros_prot_col_worksh",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "corros_prot_col_worksh" && sortedInfo?.order,
      width: 200,
      align: "center",
      editable: true,
      render: (corros_prot_col_worksh) => <div>{corros_prot_col_worksh}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">DELIVERY TO SITE</div>
            <div>{searchInput("delivery_to_site")}</div>
          </div>
        );
      },
      dataIndex: "delivery_to_site",
      key: "delivery_to_site",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "delivery_to_site" && sortedInfo?.order,
      width: 150,
      align: "center",
      editable: true,
      render: (delivery_to_site) => <div>{delivery_to_site}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">SITE RECEIPT</div>
            <div>{searchInput("site_receipt")}</div>
          </div>
        );
      },
      dataIndex: "site_receipt",
      key: "site_receipt",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "site_receipt" && sortedInfo?.order,
      width: 120,
      align: "center",
      editable: true,
      render: (site_receipt) => <div>{site_receipt}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">% COMPL.</div>
            <div>{searchInput("percent_complete")}</div>
          </div>
        );
      },
      dataIndex: "percent_complete",
      key: "percent_complete",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "percent_complete" && sortedInfo?.order,
      width: 100,
      align: "center",
      editable: true,
      render: (percent_complete) => <div>{percent_complete}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">
              <div>
                <div>Attach</div>
                <div style={{ color: "transparent" }}>_</div>
              </div>
            </div>
          </div>
        );
      },
      dataIndex: "images",
      key: "images",
      sorter: false,
      sortOrder: sortedInfo?.columnKey === "images" && sortedInfo?.order,
      width: 70,
      editable: true,
      align: "center",
      render: (_, record) => {
        if (currentUpdateObj.id !== record.id) {
          return (
            <div
              className={`attach-parent-div  ${
                (isAddProjectDistribution || isUpdateProjectDistribution) &&
                "disable-icon"
              }`}
              onClick={() => {
                if (isAddProjectDistribution || isUpdateProjectDistribution) {
                  return;
                } else {
                  setCurrentUpdateObj(record);
                  setAttachPopupVisible(true);
                }
              }}
            >
              <AttachIcon
                className="rotate-icon activities-attach"
                width={16}
                fill="#231f20"
              />
              <div>{record?.images?.length || 0}</div>
            </div>
          );
        }

        return (
          <NonEditRowAttach
            images={record?.images || []}
            setImages={setImages}
            attachPopupVisible={attachPopupVisible}
            setAttachPopupVisible={setAttachPopupVisible}
            record={record}
            setCurrentUpdateObj={setCurrentUpdateObj}
            currentUpdateObj={currentUpdateObj}
            parentRecordID={parentRecordID}
          />
        );
      },
    },
    {
      title: "",
      dataIndex: "operation",
      align: "center",
      width: 80,
      render: (_, record) => {
        const editable = isEditing(record);
        let key = record?.key || record?.id;
        return editable ? (
          editingLoading && editingKey === key ? (
            <SpinnerComponent fontSize={14} />
          ) : (
            <Space size={20} align="center">
              <Popconfirm
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                placement="rightTop"
                overlayClassName="activities-popconfirm"
                title="Are you sure you want to save this Distribution?"
                onConfirm={() => save(record.key || record.id)}
                okText="Yes"
                cancelText="No"
              >
                <SaveIcon className="custom-icon" />
              </Popconfirm>
              {/* {!isUpdateProjectDistribution && ( */}
              <Popconfirm
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                title="Are you sure you want to cancel?"
                onConfirm={cancel}
                okText="Yes"
                cancelText="No"
              >
                <CrossIcon
                  className="custom-icon"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              </Popconfirm>
              {/* // )} */}
            </Space>
          )
        ) : (
          <div>
            <Space size={20} align="center">
              {deletingLoading && record.id === deletingActivityId ? (
                <SpinnerComponent fontSize={16} />
              ) : (
                <>
                  {canEdit && (
                    <EditIcon
                      className={`custom-icon ${
                        (isAddProjectDistribution ||
                          isUpdateProjectDistribution) &&
                        "disable-icon"
                      }`}
                      disabled={editingKey !== ""}
                      onClick={() =>
                        !isAddProjectDistribution &&
                        !isUpdateProjectDistribution &&
                        edit({ ...record, isAdd: false })
                      }
                    />
                  )}
                  {!isAddProjectDistribution && !isUpdateProjectDistribution
                    ? canDelete && (
                        <Popconfirm
                          getPopupContainer={() =>
                            document.getElementsByClassName(
                              "ant-layout-content layout-content site-layout-background custom-textarea"
                            )[0]
                          }
                          placement="rightTop"
                          title="Are you sure you want to delete this Distribution?"
                          onConfirm={() => deleteDistributionHandler(record)}
                        >
                          <DeleteIcon className={`custom-icon`} />
                        </Popconfirm>
                      )
                    : canDelete && (
                        <DeleteIcon
                          className={`custom-icon ${
                            (isAddProjectDistribution ||
                              isUpdateProjectDistribution) &&
                            "disable-icon"
                          }`}
                        />
                      )}
                </>
              )}
            </Space>
          </div>
        );
      },
    },
  ];

  const handleAdd = () => {
    setShowTable(true);
    setSortedInfo(null);
    handleUpdateStatus(true, false);
    setCurrentUpdateObj({});
    let key = Math.ceil(Math.random() * 2345678);
    const newData = {
      key,
      id: key,
      distribution_date: moment(),
      username: user?.first_name + " " + user?.surname,
      rev: null,
      issued_by: null,
      issued_to: null,
      no_of_copies: null,
      copy_size: null,
      transmittal_no: null,
      comment: null,
      revision_status_id: null,
      images: null,
      isAdd: true,
    };
    setData((data) => [newData, ...data]);
    // setCount(1);
    edit(newData);
    setImages([]);
    form.setFieldsValue({
      ...newData,
    });

    setEditingKey(key);
  };

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => {
        return {
          record,
          // inputType:,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
        };
      },
    };
  });

  const handleFinish = (item) => {
    const { distribution_date } = item;
    if (isUpdateProjectDistribution) {
      dispatch(
        actions.updateProjectDistribution({
          ...item,
          distribution_date: moment(distribution_date),
          id: currentUpdateObj.id,
          ...(images.length > 0 && { images }),
          parentRecordID,
          user_id: user.id,
          debouncedCallApi,
        })
      );
    } else {
      dispatch(
        actions.createProjectDistribution({
          ...item,
          distribution_date: moment(distribution_date),
          ...(images.length > 0 && { images }),
          parentRecordID,
          user_id: user.id,
          debouncedCallApi,
        })
      );
    }
  };

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  return (
    <Row className="revisions-parent-row">
      <Col span={24} className="heading-col">
        <Row align="middle">
          <Col>
            <div className="revisions-heading-div">
              <div onClick={() => setShowTable(!showTable)}>
                {showTable ? (
                  <UpCircleOutlined className="revision-up-down-icon" />
                ) : (
                  <DownCircleOutlined className="revision-up-down-icon" />
                )}
              </div>
              <div>
                <span
                  className="heading-span"
                  style={{
                    cursor: "text",
                  }}
                >
                  DISTRIBUTION{" "}
                  {allProjectDistributions.length > 0 &&
                    `(${allProjectDistributions.length})`}
                </span>
              </div>
            </div>
          </Col>
          {canEdit && (
            <Col>
              <Button
                icon={<PlusOutlined />}
                className="add-revisions-btn"
                size="small"
                onClick={handleAdd}
                disabled={
                  isAddProjectDistribution ||
                  fetchingLoading ||
                  isUpdateProjectDistribution
                }
              >
                DISTRIBUTION
              </Button>
            </Col>
          )}
        </Row>
      </Col>

      {showTable && (
        <Col span={24}>
          <Form form={form} component={false} onFinish={handleFinish}>
            <Table
              scroll={{ x: 1200 }}
              className="special-table ims-doc-table revisions-table"
              components={{
                body: {
                  cell: (props) => (
                    <RevisionsEditableCell
                      cell={props}
                      images={images}
                      setImages={setImages}
                      attachPopupVisible={attachPopupVisible}
                      setAttachPopupVisible={setAttachPopupVisible}
                      currentUpdateObj={currentUpdateObj}
                      values={form.getFieldsValue()}
                    />
                  ),
                },
              }}
              rowKey={(record) => record.id}
              loading={fetchingLoading}
              rowClassName="editable-row"
              dataSource={data}
              columns={mergedColumns}
              onChange={handleChange}
              pagination={false}
            />
          </Form>
        </Col>
      )}
    </Row>
  );
}

export default DistributionsTable;
